import app from './app';
import auth from './auth';
import product from './product';
import transaction from './transaction';
import wishlist from './wishlist';

export default {
  app,
  auth,
  product,
  transaction,
  wishlist
};



// WEBPACK FOOTER //
// ./src/modules/index.js